import { AcousticSettingsPreset, IAcousticSettings, auditoriumReverbSettings, forestReverbSettings, getReverbSettingsForPreset } from '../../models/AcousticSettings';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: IAcousticSettings = {
	preset: AcousticSettingsPreset.Forest,
	reverbSettings: forestReverbSettings,
};

const reducer = (state: IAcousticSettings = initialState, action: Action): IAcousticSettings => {
	switch (action.type) {
		case ActionType.SET_ACOUSTIC_SETTINGS_PRESET: {
			return {
				preset: action.payload.preset,
				reverbSettings: getReverbSettingsForPreset(
					action.payload.preset,
					state.reverbSettings
				),
			};
		}
		case ActionType.SET_CUSTOM_ACOUSTIC_SETTINGS: {
			return {
				preset: AcousticSettingsPreset.Custom,
				reverbSettings: action.payload.reverbSettings,
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		default:
			return state;
	}
};


export default reducer;
